import { getUserPermissions } from 'shared-helpers/users';

import type { LocaleMessages, ServerConfig } from 'shared-types';

const getAvailableUserPermissions = ({
  messages,
  serverConfig
}: {
  messages: LocaleMessages;
  serverConfig: Pick<
    ServerConfig,
    | 'hideAchievementsFromUI'
    | 'hideCalendarEventsFromUI'
    | 'hideCoursesFromUI'
    | 'hidePathsFromUI'
    | 'featureFlags'
    | 'aiConfig'
  >;
}) => {
  const disabledPermissions = {
    'create-achievements': serverConfig.hideAchievementsFromUI,
    'create-events': serverConfig.hideCalendarEventsFromUI,
    'create-courses': serverConfig.hideCoursesFromUI,
    'create-paths': serverConfig.hidePathsFromUI,
    'grant-competencies':
      !serverConfig.featureFlags.enableCompetencyImprovements,
    'manage-competencies':
      !serverConfig.featureFlags.enableCompetencyImprovements,
    'manage-competency-profiles':
      !serverConfig.featureFlags.enableCompetencyImprovements,
    'use-ai-tools':
      !serverConfig.aiConfig?.enabled || serverConfig.aiConfig?.allowAllAdmins
  };

  const permissions = getUserPermissions({ messages });

  for (const [permission, disabled] of Object.entries(disabledPermissions)) {
    if (disabled) {
      delete permissions[permission];
    }
  }

  return permissions;
};

export default getAvailableUserPermissions;
